module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1467748"
    }
  }, [_c('b', [_vm._v("PROSCIUTTO WITH MELON")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1468248"
    }
  }, [_c('b', [_c('i', [_vm._v("The marriage of sweet ripe melon and salty prosciutto is a classic combination. Imported prosciutto di Parma, available at Italian grocers and specialty food markets, is much milder than the domestic varieties of this ham. It’s worth seeking out.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1470448"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1470948"
    }
  }, [_vm._v("1 small honeydew melon or 1medium "), _c('br'), _vm._v(" cantaloupe, chilled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1471548"
    }
  }, [_vm._v("4 ounces prosciutto, thinly sliced "), _c('br'), _vm._v(" freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1472348"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Cut melon in half through stem end and remove seeds. Cut each half into 4 wedges; cut off rind.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1473348"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Arrange 2 melon wedges on each of four plates; arrange prosciutto to side of melon. Sprinkle pepper on each serving. Makes 4 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1475048"
    }
  }, [_vm._v("Each serving: About 150 calories, 9g protein, 22g carbohydrate, 4g total fat (1g saturated), 23mg cholesterol, 548mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1476048"
    }
  }, [_c('b', [_vm._v("PROSCIUTTO WITH OTHER FRUIT")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1476548"
    }
  }, [_vm._v("Prepare as directed but substitute "), _c('b', [_vm._v("8 large green or black figs, ")]), _vm._v("each cut in half, or "), _c('b', [_vm._v("2 medium papayas, ")]), _vm._v("peeled, seeded, and sliced, for melon.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e553c7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c42_r1.vue
// module id = 192
// module chunks = 0